import React from 'react'
import AddNewCogenplant from './AddNewCogenplant'
import BreadCrumb from './AddBreadCrumb';
function AddCogeneration() {
    return ( 
        <div className = "container-fluid">
        <BreadCrumb />
        <AddNewCogenplant />
        </div>
     );
}

export default AddCogeneration;